import { apiClient } from './auth';

export const usersService = {
  async getUsers({ page = 1, pageSize = 10, role = '', search = '' }: { page?: number; pageSize?: number; role?: string; search?: string }) {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      ...(role && { role }),
      ...(search && { search }),
    });
    return apiClient.get(`/admin/users?${params}`);
  },

  async getUser(id: string) {
    return apiClient.get(`/admin/users/${id}`);
  },

  async updateUser(id: string, data: any) {
    return apiClient.put(`/admin/users/${id}`, data);
  },
};
